import * as yup from 'yup';

import { errorText } from './validationTexts';

// Step 1: About Company
export const applicationAboutSchema = yup.object({
    orgnr: yup
        .number()
        .integer(errorText.orgnrLength)
        .positive(errorText.orgnrLength)
        .typeError(errorText.orgnrLength)
        .required(errorText.orgnrLength),

    confirmOwner: yup.boolean().required(errorText.confirmOwnerText).oneOf([true], errorText.confirmOwnerText),
});

// Step 2: Contact Information
export const applicationContactSchema = yup.object({
    email: yup.string().email(errorText.emailInvalid).required(errorText.emailMissing),

    phone: yup
        .string()
        .typeError(errorText.mobileLength)
        .length(errorText.mobileLengthVal, errorText.mobileLength)
        .required(errorText.mobileLength),
});

// Step 4: Signature
export const applicationSignatureSchema = yup.object({
    signatories: yup.array().of(
        yup.object({
            ssn: yup
                .string()
                .matches(/^[0-9]{2}[0,1][0-9][0-9]{2}[ ]?[0-9]{5}$/, errorText.ssn)
                .length(errorText.ssnLengthVal, errorText.ssn)
                .required(errorText.ssn),

            name: yup.string().required(errorText.name),

            email: yup.string().email(errorText.emailInvalid).required(errorText.emailMissing),

            mobileNo: yup
                .string()
                .typeError(errorText.mobileLength)
                .length(errorText.mobileLengthVal, errorText.mobileLength)
                .required(errorText.mobileLength),
        }),
    ),
});

/* Feedback */
export const feedbackSchema = yup.object({
    feedbackMessage: yup.string().required(errorText.feedbackMessageRequired).max(500, errorText.feedbackMessageMax),
});
